export default "__VITE_ASSET__B4hPF8nu__"